var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "table-component",
        {
          ref: "table",
          attrs: {
            "show-filter": false,
            data: _vm.fetchData,
            "table-class": "table",
          },
        },
        [
          _c("table-column", {
            attrs: {
              label: _vm.$t("islamic_finance.islamic_finance_number"),
              show: "islamic_finance_number",
            },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("islamic_finance.payment_date"),
              show: "formattedPaymentDate",
            },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("islamic_finance.delivery_date"),
              show: "formattedDeliveryDate",
            },
          }),
          _vm._v(" "),
          _vm.userType === "funder" || _vm.userType === "auditor"
            ? _c("table-column", {
                attrs: { label: _vm.$t("islamic_finance.supplier") },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (row) {
                        return [
                          row.customer
                            ? _c("p", [
                                row.customer.compnay_name
                                  ? _c("span", [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(row.customer.compnay_name) +
                                          "\n          "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1893880129
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("islamic_finance.customer") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    row.customer
                      ? _c("p", [
                          row.customer.parent_account &&
                          row.customer.parent_account.company_name
                            ? _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      row.customer.parent_account.company_name
                                    ) +
                                    "\n          "
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("invoices.amount"), "sort-as": "total" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.$t("invoices.amount")))]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$utils.formatMoney(
                            row.total,
                            row.customer.currency
                          )
                        ),
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("invoices.status"), "sort-as": "status" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (row) {
                    return row.status
                      ? [
                          _c("span", [
                            _vm._v(" " + _vm._s(_vm.$t("invoices.status"))),
                          ]),
                          _vm._v(" "),
                          row.status === "OFFER_TO_SELL_ACCEPT"
                            ? _c(
                                "span",
                                { class: "status-offer-to-sell-accept" },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(row.status.replaceAll("_", " ")) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : row.status === "OFFER_TO_SELL_REJECT"
                            ? _c(
                                "span",
                                { class: "status-offer-to-sell-reject" },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(row.status.replaceAll("_", " ")) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : row.status === "NOTICE_OF_DELIVERY_ISSUED"
                            ? _c(
                                "span",
                                { class: "status-offer-to-sell-delivery" },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(row.status.replaceAll("_", " ")) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : row.status === "AGENT_APPOINTED"
                            ? _c(
                                "span",
                                {
                                  class: "status-offer-to-sell-agent-appointed",
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(row.status.replaceAll("_", " ")) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : row.status === "SALE_CONFIRMED"
                            ? _c(
                                "span",
                                {
                                  class: "status-offer-to-sell-confirmed-sale",
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(row.status.replaceAll("_", " ")) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : row.status === "INVOICE_INFORMATION_ADDED"
                            ? _c(
                                "span",
                                {
                                  class:
                                    "status-offer-to-sell-invoice-info-added",
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(row.status.replaceAll("_", " ")) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : row.status === "INVOICE_VERIFIED"
                            ? _c(
                                "span",
                                {
                                  class:
                                    "status-offer-to-sell-invoice-verification",
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(row.status.replaceAll("_", " ")) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : _c("span", {
                                class: "inv-status-" + row.status.toLowerCase(),
                                domProps: { innerHTML: _vm._s(row.status) },
                              }),
                        ]
                      : undefined
                  },
                },
              ],
              null,
              true
            ),
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("invoices.invoice_number"),
              show: "invoice_number",
            },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("funders.added_on"),
              "sort-as": "created_at",
              show: "formattedCreatedAt",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }